/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetRudoFoldersQueryResponse, SocialExportGetRudoFoldersPathParams, SocialExportGetRudoFolders400, SocialExportGetRudoFolders401, SocialExportGetRudoFolders403, SocialExportGetRudoFolders404 } from "../models/SocialExportGetRudoFolders";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetRudoFolders } from "../axios/socialExportGetRudoFolders";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetRudoFoldersQueryKey = (connectionId: SocialExportGetRudoFoldersPathParams["connectionId"]) => ["api-v2", { url: '/social-export/v1/platforms/rudo/:connectionId/folders', params: {connectionId:connectionId} }] as const

export type SocialExportGetRudoFoldersQueryKey = ReturnType<typeof socialExportGetRudoFoldersQueryKey>

export function socialExportGetRudoFoldersQueryOptions(connectionId: SocialExportGetRudoFoldersPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetRudoFoldersQueryKey(connectionId)
        return queryOptions<SocialExportGetRudoFoldersQueryResponse, ResponseErrorConfig<SocialExportGetRudoFolders400 | SocialExportGetRudoFolders401 | SocialExportGetRudoFolders403 | SocialExportGetRudoFolders404>, SocialExportGetRudoFoldersQueryResponse, typeof queryKey>({
         enabled: !!(connectionId),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetRudoFolders(connectionId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns folders available on the connected Rudo account for selecting a publish destination.
 * @summary List Rudo folders for a connection
 * {@link /social-export/v1/platforms/rudo/:connectionId/folders}
 */
export function useSocialExportGetRudoFolders<TData = SocialExportGetRudoFoldersQueryResponse, TQueryData = SocialExportGetRudoFoldersQueryResponse, TQueryKey extends QueryKey = SocialExportGetRudoFoldersQueryKey>(connectionId: SocialExportGetRudoFoldersPathParams["connectionId"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetRudoFoldersQueryResponse, ResponseErrorConfig<SocialExportGetRudoFolders400 | SocialExportGetRudoFolders401 | SocialExportGetRudoFolders403 | SocialExportGetRudoFolders404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetRudoFoldersQueryKey(connectionId)
         

         const query = useQuery({
          ...socialExportGetRudoFoldersQueryOptions(connectionId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetRudoFolders400 | SocialExportGetRudoFolders401 | SocialExportGetRudoFolders403 | SocialExportGetRudoFolders404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}